/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

import { GetDayName } from '../../../../../../Shared/Utilities/utils';
import { IFieldProps, weekNumbers } from '../../AllSchedules.Model';

import { Options } from '../../../../../../Shared/Components/Common/Dropdown/Dropdown.styles';
import { wrapperStyles } from '../../AllJobs.Style';

const { textField } = wrapperStyles;

export const DayField = ({ control, quarterName, onFieldChange, selectProps }: IFieldProps) => (
  <Controller
    name={`quarters.${quarterName}.day`}
    control={control}
    render={({ field }) => (
      <TextField
        {...field}
        select
        label="Day"
        fullWidth
        sx={{ ...textField, width: '22.5rem', marginRight: '1.5rem' }}
        SelectProps={selectProps}
        onChange={(e) => {
          field.onChange(e);
          onFieldChange?.('day', e.target.value);
        }}>
        {weekNumbers.map((d) => (
          <Options key={d} value={d}>
            {GetDayName(d)}
          </Options>
        ))}
      </TextField>
    )}
  />
);
